import { endFieldEdit } from './controls.js';
import { renderLeft } from './rail-left.js';
import { renderRight } from './rail-right.js';

/* The two rails were one 819-line file: the layer list, the inspector and the
   stage/view chrome, which share nothing but both being made of panels.

   This stays as the entry point because a dozen modules import renderRails,
   goStage and the rest from here, and rewriting every one of them would
   bury the change that actually matters under a much larger diff. */

/* Both rails, and the seam where an in-progress field edit is ended rather
   than deferred around — see controls.js's endFieldEdit for why that split
   falls here and not inside renderRight. */
export function renderRails(){ endFieldEdit(); renderLeft(); renderRight(); }

export { renderLeft } from './rail-left.js';
export { embedPhoto, noteScreenBaseline, refreshInspectorValues, renderRight, setEmbedPhoto, syncCornerWidth } from './rail-right.js';
export { goStage, setGizmoMode, setView, syncGizmoBar, updateHint } from './chrome.js';
